export const productList = [
  // {
  //   productName: "测试课程",
  //   productPrice: 1061,
  //   courseId: "620420980604370944",
  // },
  {
    productName: "《现代保健报》修改发表一站式1版",
    productPrice: 1060,
    courseId: "1212745329583779840",
  },
  {
    productName: "《现代保健报》修改发表一站式2版",
    productPrice: 1560,
    courseId: "1212745334214291456",
  },
  {
    productName: "《家庭科学·新健康》修改发表一站式1版",
    productPrice: 980,
    courseId: "1212745340551876608",
  },
  {
    productName: "《家庭科学·新健康》修改发表一站式2版",
    productPrice: 1480,
    courseId: "1212745344670683136",
  },
];
